import IndeterminateCheckboxes from "./indeterminate_checkboxes";
import SelectTag from "./select_tag";
export default class MultiSelectTag extends SelectTag {
  constructor(node) {
    super(node);

    this.element = node;
    this.checkedValues = [];
    this.defaultText = this.element.dataset.defaultText;
  }

  handleSelectTagClick(e) {
    e.preventDefault();
    const { target } = e;

    const input = target.querySelector("input");
    input.checked = !input.checked;
    input.dispatchEvent(new Event("change"));
    this.inputElement.dispatchEvent(new Event("change"));
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
    this.selectBtn.setAttribute("aria-expanded", this.selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true");

    if (this.dropdownVisible) {
      document.body.appendChild(this.dropdownElement);

      this.checkboxes = this.dropdownElement.querySelectorAll(".js-multi-select-checkbox");

      new IndeterminateCheckboxes(this.dropdownElement);

      this.dropdownElement.addEventListener("indeterminate-changed", () => {
        let arrayOfValues = [];
        this.checkedValues = [];

        this.checkboxes.forEach((checkbox) => {
          const { checked } = checkbox;

          if (checked) {
            if (checkbox.value != "all") {
              const text = checkbox.parentElement.querySelector(".js-select-value").innerText;
              this.checkedValues.push(text);
              arrayOfValues.push(checkbox.value);
            }
          }
        });

        this.inputElement.value = arrayOfValues.toString();

        this.updateSelection();
      });
      this.setDropdownPosition();
      document.addEventListener("click", this.boundFunction);
    } else {
      document.removeEventListener("click", this.boundFunction);

      this.dropdownElement.remove();
    }
  }

  updateSelection() {
    this.checkedValues.length === 0 ? (this.selectedValue.innerText = this.defaultText) : (this.selectedValue.innerText = "");

    this.checkedValues.forEach((value, index) => {
      index === 0 ? (this.selectedValue.innerText += value) : (this.selectedValue.innerText += `, ${value}`);
    });
  }
}
